import { Injectable } from '@angular/core';

import { AngularFireAuth } from 'angularfire2/auth';
import * as firebase from 'firebase/app';

import { Observable } from 'rxjs/Observable';
import { switchMap, map } from 'rxjs/operators';
import { AngularFirestore } from 'angularfire2/firestore';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Booking } from '../models/booking';
import { of } from 'rxjs/observable/of';

import * as adminActions from '../../store/actions/admin.action';

@Injectable()
export class BookingService {
  user: Observable<firebase.User>;
  constructor(
    private db: AngularFirestore,
    private firebaseAuth: AngularFireAuth,
    private store: Store<any>,
    private router: Router
  ) {
    this.user = firebaseAuth.authState;
  }

  addBooking(booking: Booking): Observable<any> {
    return this.user.pipe(
      switchMap(auth => {
        if (auth) {
          return this.db.collection(`/users/${auth.uid}/bookings`).add({
            // id: `${booking.firstNames} ${booking.lastName}`,
            groupId: auth.email,
            title: booking.title,
            firstNames: booking.firstNames,
            lastName: booking.lastName,
            email: booking.email,
            gender: booking.gender,
            country: booking.country,
            idNumber: booking.idNumber,
            mobilePhone: booking.mobilePhone,
            nameOfChurch: booking.nameOfChurch,
            groupASession: booking.groupASession,
            groupBSession: booking.groupBSession,
            expertise: booking.expertise,
            includeInBusiness: booking.includeInBusiness,
            arrivalDate: booking.arrivalDate,
            departureDate: booking.departureDate,
            meal1: booking.meal1,
            meal2: booking.meal2,
            meal3: booking.meal3,
            otherInfo: booking.otherInfo,
            packageChoice: booking.packageChoice,
            hotelChoice1: booking.hotelChoice1,
            hotelChoice2: booking.hotelChoice2,
            hotelChoice3: booking.hotelChoice3,
            includeSowetoTour: booking.includeSowetoTour,
            includeUnionBuildingTour: booking.includeUnionBuildingTour,
            includeSunCityTour: booking.includeSunCityTour,
            includeGoldReefCityTour: booking.includeGoldReefCityTour,
            tours: booking.tours,
            bookingPrice: booking.bookingPrice,
            includeNgyn: booking.includeNgyn,
            ngynFee: booking.ngynFee,
            bookingDate: new Date()
          });
        }
      })
    );
  }

  // updateBooking(booking): Observable<any> {
  //   return this.user.pipe(
  //     switchMap(auth => {
  //       if (auth) {
  //         return this.db
  //           .doc(`/users/${auth.uid}/bookings/${booking.id}`)
  //           .update({
  //             groupId: auth.email,
  //             title: booking.title,
  //             firstNames: booking.firstNames,
  //             lastName: booking.lastName,
  //             email: booking.email,
  //             gender: booking.gender,
  //             country: booking.country,
  //             idNumber: booking.idNumber,
  //             mobilePhone: booking.mobilePhone,
  //             nameOfChurch: booking.nameOfChurch,
  //             trackSessions: booking.trackSessions,
  //             includeInBusiness: booking.includeInBusiness,
  //             expertise: booking.expertise,
  //             arrivalDate: booking.arrivalDate,
  //             departureDate: booking.departureDate,
  //             meal1: booking.meal1,
  //             meal2: booking.meal2,
  //             meal3: booking.meal3,
  //             otherInfo: booking.otherInfo,
  //             packageChoice: booking.packageChoice,
  //             hotelChoice1: booking.hotelChoice1,
  //             hotelChoice2: booking.hotelChoice2,
  //             hotelChoice3: booking.hotelChoice3,
  //             includeSowetoTour: booking.includeSowetoTour,
  //             includeUnionBuildingTour: booking.includeUnionBuildingTour,
  //             includeSunCityTour: booking.includeSunCityTour,
  //             includeGoldReefCityTour: booking.includeGoldReefCityTour,
  //             tours: booking.tours,
  //             bookingPrice: booking.bookingPrice
  //           });
  //       }
  //     })
  //   );
  // }

  getAllBookings() {
    const bookings = [];
    const usersCollection = this.db.collection('/users');
    return usersCollection.snapshotChanges().map(actions => {
      return actions.map(a => {
        const userId = a.payload.doc.id;
        const bookingCollection = usersCollection.ref
          .doc(userId)
          .collection('bookings')
          .get();
        return bookingCollection
          .then(col => {
            if (!col.empty) {
              col.docs.forEach(doc => {
                bookings.push(doc.data());
              });
              this.store.dispatch(
                new adminActions.GetAllBookingsSuccess(bookings)
              );
              return bookings;
            }
          })
          .catch(error =>
            this.store.dispatch(new adminActions.GetAllBookingsFail(error))
          );
      });
    });
  }

  getBookings(): Observable<any> {
    return this.user.pipe(
      switchMap(auth => {
        if (auth) {
          return this.db
            .collection(`/users/${auth.uid}/bookings`)
            .snapshotChanges()
            .map(actions => {
              return actions.map(a => {
                const data = a.payload.doc.data();
                const id = a.payload.doc.id;
                return { id, ...data };
              });
            });
        }
      })
    );
  }

  getBooking(bookingId): Observable<any> {
    return this.user.pipe(
      switchMap(auth => {
        if (auth) {
          return this.db
            .doc(`/users/${auth.uid}/bookings/${bookingId}`)
            .snapshotChanges()
            .map(action => {
              const data = action.payload.data();
              const id = action.payload.id;
              return { id, ...data };
            });
        }
      })
    );
  }

  deleteBooking(bookingId): Observable<any> {
    return this.user.pipe(
      switchMap(auth => {
        if (auth) {
          return this.db
            .doc(`/users/${auth.uid}/bookings/${bookingId}`)
            .delete();
        }
      })
    );
  }
}



// WEBPACK FOOTER //
// /Users/abassey/side-proj/emp21-new/src/app/booking/services/booking.service.ts